export default {
      id: "arrow-down-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }